import React from 'react';
import Websocket from 'react-websocket';
import ScanSuccess from '../success/scanSuccess';
import RightBox from './rightBox/index';
import getSize from '../../../utils/getSize';
import styles from './styles.css';
import line from './images/line1.png';
import NHFetch from "../../../utils/NHFetch";

let showTime = -1;

export default class Scan extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            screenW:getSize().windowW,
            screenH:getSize().windowH,
            scanShow: true,         //扫描页面标志
            successShow: false,     //扫描成功标志
            data: {},                //认证成功数据
            dqxxmc:'',
            rlsbUri:'',     //人脸识别URI
        }
    }

    componentWillMount(){
        this.setRem();
        this.getXxxx();
        this.getRlsbUri();
    }

    componentDidMount(){
        window.onresize=()=>{
            this.setRem();
        }
    }

    //获取人脸识别URI
    getRlsbUri = () => {
        NHFetch("api/zhxg-yxxt/rlsb/getRlsbUri", "GET")
            .then(resData => {
                if (resData && resData.data) {
                    this.setState({
                        rlsbUri: resData.data
                    });
                }
            });
    };

    //获取移动迎新网站LOGO
    getXxxx = () => {
        NHFetch("api/zhxg-xtgl/schoolMng/queryDqxx","GET")
            .then(resData => {
                if(resData && resData.data){
                    this.setState({
                        dqxxmc:resData.data['xxmc']
                    });
                }
            });
    };

    setRem=()=>{// 设置rem值
        this.setState({
            screenW:getSize().windowW,
            screenH:getSize().windowH,
        },()=>{
            let _this=this;
            // 表示1920的设计图,使用100PX的默认值
            let widdef = 100 / 1920;
            // 当前窗口的宽度----screenW
            // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
            let rem = parseInt(_this.state.screenW * widdef);
            // console.log('rem========9090',rem);
            window.rem = rem;
            window.document.documentElement.style.fontSize = rem + 'px';
        });
    }

    componentWillUnmount(){//移除设置在根源素上的rem属性
        window.document.documentElement.style.fontSize = '';
    }


    showScan = () => {
        setTimeout(() => {
            if (showTime === 0) {//倒计时结束了，此时要重新显示等待界面
                this.setState({
                    scanShow: true,
                    successShow: false
                });
                showTime = -1;
            } else if (showTime > 0) {
                showTime = showTime - 1;
                this.showScan();
            }
        }, 1000);
    };

    handleData(data) {
        this.setState({
            data: JSON.parse(data),
            scanShow: false,
            successShow: true
        });
        if (showTime === -1) {//说明此时正处于显示学生信息的界面
            showTime = 30;
            this.showScan();
        } else {
            showTime = 30;
        }
    };

    render() {
        const {screenW,screenH,dqxxmc,rlsbUri}=this.state;
        let { ip } = this.props.match.params;
        let url = '';
        const nodeEnv = process.env.NODE_ENV || 'development';
        if (nodeEnv === 'development') {//开发环境
            url = "ws://127.0.0.1:6023/websocket/" + ip;
        } else { //生产环境
            // url='ws://'+window.location.href.split('#')[0].substring(7)+'api/zhxg-rlsb/websocket/'+ip;
            url = `ws://${rlsbUri}/websocket/` + ip;
        }

        return (
            <div style={{ width:screenW, height:screenH , overflow: 'auto', }}>
                <div className={styles.bigbox}>
                    <div className={styles.leftBox}>
                        <div className={styles.logoBox}>
                            <img src={'api/zhxg-xtgl/schoolMng/downloadSchoolPictureByType?type=logo'} style={{width:'52px',height:'45px'}} className={styles.logo} alt="" />
                            {/* <span className={styles.logoName}>联奕大学</span> */}
                            <span className={styles.logoName}>{dqxxmc}</span>
                            <img src={line} alt="" className={styles.line} />
                            <span className={styles.text}>人脸识别报到体验区</span>
                        </div>
                        {/*扫描前*/}
                        <div className={`${styles.faceBox}`} style={this.state.scanShow ? { transform: ' scale(1)', transition: 'all 1s' } : { transform: ' scale(0)', transition: 'all 1s' }}>
                            <div className={styles.faceBg} />
                        </div>

                        {/*扫描成功页面*/}
                        <div className={`${styles.infoBox}`} style={this.state.successShow ? { transform: ' scale(1)', transition: 'all 1s' } : { transform: 'scale(0)', transition: 'all 1s' }}>
                            <ScanSuccess data={this.state.data} />
                        </div>
                    </div>
                    <RightBox>
                    </RightBox>
                </div>
                <Websocket url={url} onMessage={this.handleData.bind(this)} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/face/scan/index.js